"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTwoArgsFnCondition = void 0;
const index_js_1 = require("../../../../../attributes/string/index.js");
const index_js_2 = require("../../../../../attributes/string/index.js");
const types_js_1 = require("./types.js");
const twoArgsFnOperatorExpression = {
    contains: 'contains',
    beginsWith: 'begins_with',
    type: 'attribute_type'
};
const stringAttribute = (0, index_js_2.string)().freeze();
const typeAttribute = (0, index_js_2.string)()
    .enum('S', 'SS', 'N', 'NS', 'B', 'BS', 'BOOL', 'NULL', 'L', 'M')
    .freeze();
const parseTwoArgsFnCondition = (conditionParser, condition) => {
    const comparisonOperator = Object.keys(condition).find(types_js_1.isTwoArgsFnOperator);
    const attributePath = condition.attr;
    const expressionAttributeValue = condition[comparisonOperator];
    const { transform = true } = condition;
    conditionParser.resetExpression(`${twoArgsFnOperatorExpression[comparisonOperator]}(`);
    const attribute = conditionParser.appendAttributePath(attributePath);
    conditionParser.appendToExpression(', ');
    let targetAttribute;
    switch (comparisonOperator) {
        case 'type':
            targetAttribute = new index_js_1.StringAttribute({ ...typeAttribute, path: attributePath });
            break;
        case 'contains':
            switch (attribute.type) {
                case 'set':
                case 'list':
                    targetAttribute = attribute.elements;
                    break;
                case 'string':
                    // We accept any string in case of contains
                    targetAttribute = new index_js_1.StringAttribute({ ...stringAttribute, path: attributePath });
                    break;
                default:
                    targetAttribute = attribute;
            }
            break;
        default:
            targetAttribute = attribute;
    }
    comparisonOperator === 'type'
        ? conditionParser.appendAttributeValue(targetAttribute, expressionAttributeValue)
        : conditionParser.appendAttributeValueOrPath(targetAttribute, expressionAttributeValue, {
            transform
        });
    conditionParser.appendToExpression(')');
};
exports.parseTwoArgsFnCondition = parseTwoArgsFnCondition;
